import L from 'leaflet';
import _ from 'lodash';
import React from 'react';
import {GeoJSON} from 'react-leaflet';
import {connect} from 'react-redux';
import {setActivePoint} from '../actions';

const ICON = L.divIcon({ className: 'manual-weather-icon', iconSize: [5, 5] });
const ICON_ON_BURN = L.divIcon({ className: 'manual-weather-icon on-burn', iconSize: [9, 9], iconAnchor: [4, 4] });

class ManualWeatherLayer extends React.Component {
  render() {
    const { features } = this.props;
    const geo_json = { type: 'FeatureCollection', features: _.values(features) };

    return <GeoJSON key={'ManualWeather' + new Date().getTime()}
                    data={geo_json}
                    pointToLayer={this.marker}
                    zIndex={5}
                    onEachFeature={this.onEachFeature}/>;
  }

  onEachFeature = (feature, layer) => {
    const { dispatch } = this.props;
    layer.on('click', () => {
      dispatch(setActivePoint(feature.geometry.coordinates[1], feature.geometry.coordinates[0]));
    });
  };

  marker = (feature, latlng) => {
    if (feature.properties.burn) {
      return L.marker(latlng, { icon: ICON_ON_BURN });
    }
    return L.marker(latlng, { icon: ICON });
  };
}

const mapStateToProps = state => {
  return { features: state.manual_weather.features };
};

const mapDispatchToProps = dispatch => {
  return { dispatch };
};

export default connect(mapStateToProps, mapDispatchToProps)(ManualWeatherLayer);



// WEBPACK FOOTER //
// ./src/containers/ManualWeatherLayer.js